import Popover from 'src/components/popover/popover.vue'

// Dividers at the ends or next to each other say nothing; they appear when
// the items between them are hidden.
export const visibleItems = (items) =>
  items
    .filter((item) => !item.hidden)
    .filter(
      (item, index, list) =>
        !item.divider ||
        (index > 0 && index < list.length - 1 && !list[index - 1].divider),
    )
    .filter((item, index, list) => !(item.divider && index === list.length - 1))

// a drawn box or circle, unless the item shows its state as a tint
const drawsMark = (item) => 'checked' in item && item.mark !== false
const marks = (item) => (drawsMark(item) ? 1 : 0) + (item.icon ? 1 : 0)

// A popover menu from a list of items. Each item is one of:
//   { key, label, icon?, description?, action?, keepOpen?, disabled?,
//     danger?, checked? (a checkbox; 'mixed' when only some targets have
//     it), radio? (with checked), hidden?,
//     mark? (false: show the state as a tint, not a box or circle) }
//   { key, divider: true }
//   { key, heading: 'text' }
//   { key, slot: 'name' } -- the named slot, for special content
// Other attributes (placement, bounds, class) go to the Popover.
const MenuPopover = {
  inheritAttrs: false,
  components: { Popover },
  props: {
    items: { type: Array, required: true },
    // an accessible name for the trigger button
    label: { type: String, default: undefined },
  },
  computed: {
    // the caller's trigger attributes, plus the menu's own
    triggerAttrs() {
      return {
        'aria-haspopup': 'menu',
        ...(this.label && { 'aria-label': this.label, title: this.label }),
        ...(this.$attrs['trigger-attrs'] ?? this.$attrs.triggerAttrs),
      }
    },
    shown() {
      return visibleItems(this.items)
    },
  },
  methods: {
    drawsMark,
    ariaChecked(item) {
      if (!('checked' in item)) return undefined
      return item.checked === 'mixed' ? 'mixed' : String(!!item.checked)
    },
    role(item) {
      if (!('checked' in item)) return 'menuitem'
      return item.radio ? 'menuitemradio' : 'menuitemcheckbox'
    },
    rowClass(item) {
      const count = marks(item)
      return {
        '-icon': count === 1,
        '-icon-double': count === 2,
        '-danger': item.danger,
        '-active': item.checked && (item.radio || item.mark === false),
        disabled: item.disabled,
      }
    },
    run(item, close) {
      item.action?.()
      if (!item.keepOpen) close()
    },
  },
}

export default MenuPopover
